import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogActions, Box, Typography, Button } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { LanguageContext } from "context/LanguageContext";
import { COLORS } from "theme/tokens";

// 共用「升級方案」提醒視窗。
// FREE（wizardExecLimit===0）點「匯出 / 下載策略」時跳出，引導升級。
// 精靈策略管理 + AI 策略助理策略管理共用；4 語系自帶（讀 LanguageContext.language）。
const TEXT = {
  "zh-TW": {
    title: "升級方案即可匯出策略",
    desc: "您目前的免費方案無法匯出 / 下載策略執行檔。升級至 Growth 或 Pro Trader 方案，即可打包並在 MT5 執行您的策略。",
    upgrade: "查看方案 / 升級",
    later: "暫不升級",
  },
  "zh-CN": {
    title: "升级方案即可导出策略",
    desc: "您当前的免费方案无法导出 / 下载策略执行档。升级至 Growth 或 Pro Trader 方案，即可打包并在 MT5 运行您的策略。",
    upgrade: "查看方案 / 升级",
    later: "暂不升级",
  },
  en: {
    title: "Upgrade to export your strategy",
    desc: "Your current Free plan can’t export or download strategy executables. Upgrade to Growth or Pro Trader to package and run your strategy on MT5.",
    upgrade: "View plans / Upgrade",
    later: "Maybe later",
  },
};

function pickLang(language) {
  const u = String(language || "").toUpperCase();
  if (u.includes("CN")) return "zh-CN";
  if (u.includes("TW") || u.startsWith("ZH")) return "zh-TW";
  return "en";
}

export default function UpgradePlanDialog({ open, onClose, title, desc }) {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = TEXT[pickLang(language)];

  const goUpgrade = () => {
    if (onClose) onClose();
    navigate("/plans");
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogContent sx={{ textAlign: "center", pt: 4 }}>
        <Box
          sx={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: 80,
            height: 80,
            borderRadius: "50%",
            bgcolor: "rgba(243,109,38,0.10)",
            mb: 2,
          }}
        >
          <WorkspacePremiumIcon sx={{ fontSize: 60, color: COLORS.main }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: "1.15rem", color: COLORS.black, mb: 1 }}>
          {title || t.title}
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", color: COLORS.grayDark, lineHeight: 1.7 }}>
          {desc || t.desc}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5, flexDirection: "column" }}>
        <Button
          fullWidth
          variant="contained"
          onClick={goUpgrade}
          sx={{
            bgcolor: COLORS.main,
            color: COLORS.white,
            borderRadius: 2,
            py: 1.2,
            fontWeight: 700,
            textTransform: "none",
            "&:hover": { bgcolor: COLORS.main, filter: "brightness(0.95)" },
          }}
        >
          {t.upgrade}
        </Button>
        <Button
          fullWidth
          variant="text"
          onClick={onClose}
          sx={{ color: COLORS.grayDark, textTransform: "none", fontWeight: 400, ml: "0 !important" }}
        >
          {t.later}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
